import { Grid } from "@material-ui/core";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import InputPureWrapper from "../../onboarding/steps/inputs/inputPureWrapper";
import TextAreaWrapper from "../../onboarding/steps/inputs/textareaWrapper";
import { ButtonHLPure } from "../../../pures";
import { requiredValidator } from "./validator";

const NewConversationDialog = (props) => {
    const {
        onClose,
        onAddConversation,
        t,
        tCommon
    } = props;

    return <Dialog
        width={400}
        onClose={onClose}
        title={t("conversations.startNode.dialogTitle")}
    >
        <Form
            onSubmit={onAddConversation}
            render={(formRenderProps) => {
                return (
                    <FormElement>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Field
                                    id="name"
                                    name={'name'}
                                    component={InputPureWrapper}
                                    label={t("conversations.startNode.name")}
                                    validator={requiredValidator}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    id="description"
                                    name={'description'}
                                    component={TextAreaWrapper}
                                    label={t("conversations.userNode.description")}
                                    validator={requiredValidator}
                                />
                            </Grid>
                            <Grid item xs={12} className='button-actions'>
                                <ButtonHLPure colorScheme="error" outlined nameBtn={tCommon("cancel")} onClick={onClose} />
                                <ButtonHLPure primary nameBtn={tCommon("save")} type="submit" />
                            </Grid>
                        </Grid>
                    </FormElement>
                )
            }}
        />
    </Dialog>
}

export default NewConversationDialog